/**
 * Sticky "Læg i kurv" bar for mobile product pages.
 *
 * Shows a fixed bottom bar with the product title, price, and an
 * Add to cart button once the user scrolls past the main buy-buttons
 * area. Clicking the sticky button simply clicks the original submit
 * button, so all existing validation / variant logic keeps working.
 *
 * Desktop (>= 750px) is untouched.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
  var submitButton = document.querySelector('.product-form__submit');
  if (!form || !submitButton) return;

  var titleEl = document.querySelector('.product__title h1');
  var title = titleEl ? titleEl.textContent.trim() : '';

  var priceWrapper = document.querySelector('.product__info-container .price') || document.querySelector('.price');
  var priceText = '';
  if (priceWrapper) {
    var isOnSale = priceWrapper.classList.contains('price--on-sale');
    var activeEl = isOnSale
      ? priceWrapper.querySelector('.price__sale .price-item--sale')
      : priceWrapper.querySelector('.price__regular .price-item--regular');
    if (activeEl) priceText = activeEl.textContent.trim();
  }

  var buttonLabelEl = submitButton.querySelector('span');
  var buttonLabel = buttonLabelEl ? buttonLabelEl.textContent.trim() : 'Læg i kurv';

  var bar = document.createElement('div');
  bar.id = 'StickyAddToCart';
  bar.style.cssText = [
    'position: fixed',
    'bottom: 0',
    'left: 0',
    'right: 0',
    'z-index: 998',
    'display: flex',
    'align-items: center',
    'justify-content: space-between',
    'gap: 12px',
    'padding: 10px 16px',
    'padding-bottom: max(10px, env(safe-area-inset-bottom))',
    'background: rgb(var(--color-background))',
    'border-top: 1px solid rgba(var(--color-foreground), 0.1)',
    'box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08)',
    'transform: translateY(100%)',
    'transition: transform 0.25s ease',
    'will-change: transform',
  ].join(';');

  var info = document.createElement('div');
  info.style.cssText = 'flex: 1 1 auto; min-width: 0; overflow: hidden; line-height: 1.2;';

  var titleDiv = document.createElement('div');
  titleDiv.style.cssText = 'font-size: 1.2rem; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
  titleDiv.textContent = title;

  var priceDiv = document.createElement('div');
  priceDiv.style.cssText = 'font-size: 1.3rem;';
  priceDiv.textContent = priceText;

  info.appendChild(titleDiv);
  if (priceText) info.appendChild(priceDiv);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = buttonLabel;
  btn.style.cssText = [
    'flex-shrink: 0',
    'border: none',
    'border-radius: var(--buttons-radius, 0px)',
    'padding: 0 20px',
    'height: 44px',
    'background: rgb(var(--color-button))',
    'color: rgb(var(--color-button-text))',
    'font-size: 1.3rem',
    'letter-spacing: 0.06rem',
    'cursor: pointer',
  ].join(';');

  if (submitButton.disabled) {
    btn.disabled = true;
    btn.style.opacity = '0.6';
    btn.style.cursor = 'default';
  }

  btn.addEventListener('click', function () {
    submitButton.click();
  });

  bar.appendChild(info);
  bar.appendChild(btn);
  document.body.appendChild(bar);

  var visible = false;
  var ticking = false;

  function updateVisibility() {
    var rect = submitButton.getBoundingClientRect();
    var originalOnScreen = rect.top < window.innerHeight && rect.bottom > 0;
    var shouldShow = !originalOnScreen && rect.top < 0;

    if (shouldShow !== visible) {
      visible = shouldShow;
      bar.style.transform = visible ? 'translateY(0)' : 'translateY(100%)';
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );

  updateVisibility();

  // Keep the displayed price/availability in sync when the customer changes variants.
  document.addEventListener('change', function (event) {
    if (!form.contains(event.target)) return;
    window.requestAnimationFrame(function () {
      var activeEl = priceWrapper && (
        priceWrapper.classList.contains('price--on-sale')
          ? priceWrapper.querySelector('.price__sale .price-item--sale')
          : priceWrapper.querySelector('.price__regular .price-item--regular')
      );
      if (activeEl) priceDiv.textContent = activeEl.textContent.trim();

      var label = submitButton.querySelector('span');
      if (label) btn.textContent = label.textContent.trim();

      btn.disabled = submitButton.disabled;
      btn.style.opacity = submitButton.disabled ? '0.6' : '1';
      btn.style.cursor = submitButton.disabled ? 'default' : 'pointer';
    });
  });
});
